export default {"src":"/_next/static/media/hamburger-menu.5e08ef51.svg","height":24,"width":24};